// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/interception-signals.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/interception-signals/interception-signals.js';

mount([g0]);
